import React from "react";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="site-logo">
    <svg width="52" height="56" viewBox="0 0 60 65" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g stroke="#000000" strokeWidth="2" strokeLinejoin="round">
        <circle cx="42" cy="25" r="10" fill="#EC1FC4" />
        <circle cx="38.49" cy="33.49" r="10" fill="#EC1FC4" />
        <circle cx="30" cy="37" r="10" fill="#EC1FC4" />
        <circle cx="21.51" cy="33.49" r="10" fill="#EC1FC4" />
        <circle cx="18" cy="25" r="10" fill="#EC1FC4" />
        <circle cx="21.51" cy="16.51" r="10" fill="#EC1FC4" />
        <circle cx="30" cy="13" r="10" fill="#EC1FC4" />
        <circle cx="38.49" cy="16.51" r="10" fill="#EC1FC4" />
      </g>
      <path d="M27 37 L27 61 L33 61 L33 37 Z" fill="#4CD924" stroke="#000000" strokeWidth="2" strokeLinejoin="round" />
      <path d="M27 46 C15 42 3 46 3 52 C3 58 15 56 27 50 Z" fill="#4CD924" stroke="#000000" strokeWidth="2" strokeLinejoin="round" />
      <path d="M33 46 C45 42 57 46 57 52 C57 58 45 56 33 50 Z" fill="#4CD924" stroke="#000000" strokeWidth="2" strokeLinejoin="round" />
      <circle cx="30" cy="25" r="13" fill="#FBE600" stroke="#000000" strokeWidth="2" />
      <ellipse cx="25" cy="23" rx="1.6" ry="3" fill="none" stroke="#000000" strokeWidth="1.4" />
      <ellipse cx="35" cy="23" rx="1.6" ry="3" fill="none" stroke="#000000" strokeWidth="1.4" />
      <path d="M22.5 28.5 Q30 35 37.5 28.5" stroke="#000000" strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
    <span className="text-xl md:text-2xl font-bold text-kid-navy tracking-tight">Spring Kids</span>
  </div>
);
